import styled from "@emotion/styled";

export const Wrapper = styled.div`
  align-self: center;
`;
